import { CheckIcon, RadioCheckIcon, RadioUnCheckIcon, CopyIcon } from "../../../assets/icons";
import { WalletEnquiry } from "../../../model/payments/payments";
import { convertToString, handleCopy } from "../../../utils";
import styles from "./RadioButtonLong.module.scss";
import VFDLogo from '../../../assets/icons/vfd_logo.png';

export interface WalletRadioButtonLong {
	leftSection?: React.ReactNode;
	middleSection?: React.ReactNode;
	isSelected: boolean;
	onSelected: () => void;
	label?: string;
	subLabel?: string;
	isHidden?: boolean;
	data?: WalletEnquiry;
}
const WalletRadioButtonLong: React.FC<WalletRadioButtonLong> = ({
	leftSection,
	middleSection,
	isSelected,
	onSelected,
	label,
	subLabel,
	data,
	isHidden = false,
}) => {
	return (
		<div className={styles.radioContainer}>
			{label && <label className={styles.label}>{label}</label>}
			{subLabel && <label className={styles.subLabel}>{subLabel}</label>}
			<div className={styles.walletRadioContainer}>
				<div className={styles.radioContent} style={{ border: "none" }} onClick={onSelected}>
					<div>{leftSection}</div>
					<div>{middleSection}</div>
					{!isHidden && (
						<div>
							<>
								<input checked={isSelected} onChange={onSelected} type="radio" hidden />
								{isSelected ? <RadioCheckIcon /> : <RadioUnCheckIcon />}
							</>
						</div>
					)}
				</div>
				{data && (
					<div className={styles.accountDetailContainer}>
						<div className={styles.row}>
							<div className={styles.label}>Bank Name</div>
							<div className={styles.value}>VFD Microfinance Bank  <img className={styles.imageLogo} src={VFDLogo} alt="VFD"/></div>
						</div>
						<div className={styles.row}>
							<div className={styles.label}>Account Number</div>
							<div className={styles.value}>
								{data?.accountNo} <CopyIcon onClick={() => handleCopy("")} />
							</div>
						</div>
						<div className={styles.row}>
							<div className={styles.label}>Customer Name</div>
							<div className={styles.value}>{data?.client}</div>
						</div>
						<div className={styles.row}>
							<div className={styles.label}></div>
							<div className={styles.balance}>
								{data?.accountBalance.toLocaleString()} <span>NGN</span>
							</div>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};
export default WalletRadioButtonLong;
